import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { AlertsComponent } from './alerts.component';
import { MapPreviewerComponent } from './map-previewer/map-previewer.component';
import { SharedModule } from '@app/shared/shared.module';
import { EnvService } from '@app/services/env.service';
import { PersistentAlertsComponent } from './persistent-alerts/persistent-alerts.component';
import { PersistentAlertCardComponent } from './persistent-alerts/persistent-alert-card/persistent-alert-card.component';

@NgModule({
  declarations: [
    AlertsComponent,
    MapPreviewerComponent,
    PersistentAlertsComponent,
    PersistentAlertCardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    SharedModule,
  ],
  providers: [EnvService],
})
export class AlertsModule {}
